import { Component } from '@angular/core';
import { ItemsListContentBaseComponent } from '../content-base/content-base.component';

@Component({
    selector: 'fi-items-list-content-list-view',
    templateUrl: './content-list-view.component.html',
    styleUrls: ['./content-list-view.component.scss'],
    standalone: false,
})
export class ItemsListContentListViewComponent extends ItemsListContentBaseComponent {}
